import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrl: './invoices.component.scss'
})
export class InvoicesComponent implements OnInit {

  constructor() { }
  UserData: any;
  ngOnInit(): void {
    this.UserData = JSON.parse(localStorage.getItem('UserInfo') as string);
  }

}
